import * as yup from 'yup';

export const schema = yup.object().shape({
    email: yup.string().required('Ingrese un correo electronico'),
    password: yup.string().required('Ingrese una contraseña'),
});
